import { environment } from './../environments/environment';
import {HostListener, Component, OnInit, ChangeDetectorRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CommonConstants } from './common/utilities/commonConstants';
import { EmitterService } from './common/services/emitter.service';
import { RouteContextProvider } from './common/services/routeContextProvider.service';
import { CookieHandlerService } from './common/services/cookieHandler.service';
import { ConfigSingletonService } from './common/services/config.singleton.service';
import { digitalData, initiPageInfo, _satellite } from './common/services/adobe-service';

window['digitalData'] = digitalData;
window['_satellite'] = _satellite;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewChecked {
  title = 'app';
  // Bajaj Logo goes here
  public bajajclassLogo = 'assets/img/bfs-logo-mod.png';
  public angularclassLogo = 'assets/img/angularclass-avatar.png';
  public name = 'This is test page';
  public url = 'some URL';
  public MainLoadingText: string = "Stay with us. We're almost done...";
  public loaderUrl:string;
  public HasError: boolean;
  // public ErrorMessage: string = CommonConstants.DEFAULT_EMPTY_STRING;
  public IsLoadingTask = false;
  // public MainLoadingText: string = "Stay with us. We're almost done...";
  constructor(
    private _emitterService: EmitterService,
    private cdRef: ChangeDetectorRef,
    private _routeContextProvider: RouteContextProvider,
    private _cookieHandler: CookieHandlerService
  ) { }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(window.innerWidth<=768){
        this.loaderUrl= environment.IMAGES.mobLoader;
    }
    else{
      this.loaderUrl=  environment.IMAGES.desLoader;}
  }
  ngOnInit() {
    if(window.innerWidth<=768){
      this.loaderUrl= environment.IMAGES.mobLoader
  }
  else{
    this.loaderUrl= environment.IMAGES.desLoader;}
    const prodCode = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.prodCode);
    this._emitterService.Get(CommonConstants.EmitterEventTypes.LoadingEvent).subscribe(
      (isLoading: boolean) => {
        this.IsLoadingTask = isLoading;
        this.MainLoadingText = ConfigSingletonService.getInstance().getTitle();
      });
    //this.setupEnvironmentEndpoints();
    this.setProductCodeInCookie(prodCode);
  }
  public ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  private setProductCodeInCookie(productCode) {
    // const productObj = (CommonConstants.CodeMapper[productCode]) ? CommonConstants.CodeMapper[productCode] : { code: 'SOL' };
    const productObj = (CommonConstants.CodeMapper[productCode]);
    if (productObj && productObj !== '') {
      this._cookieHandler.SetCookie(CommonConstants.QueryParamsKeys.Productcode, productObj.code);
      console.log(this._cookieHandler.GetCookie(CommonConstants.QueryParamsKeys.Productcode));
    }
  }
  private addScriptToHeadTag(script: string) {
    const sc = document.createElement('script');
    sc.setAttribute('src', script);
    sc.setAttribute('type', 'text/javascript');
    document.head.appendChild(sc);
  }
  private setupEnvironmentEndpoints() {
    switch (environment['name']) {
      case 'uat':
        console.log('::: UAT :::');
         this.addScriptToHeadTag('//assets.adobedtm.com/launch-ENfb16a972f8f74a31ad0115faf18cbc60-development.min.js');
        break;
      case 'qa':
        console.log('::: QA :::');
         this.addScriptToHeadTag('//assets.adobedtm.com/launch-ENfb16a972f8f74a31ad0115faf18cbc60-development.min.js');
        break;
      case 'prod':
        console.log('::: PROD :::');
         this.addScriptToHeadTag('//assets.adobedtm.com/launch-EN9e1d3a4c70664eeeabde3c697c0bfb6c.min.js');
        break;
      default:
        break;
    }
  }
}
